module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "calendar.370910b3.svg";